import { useEffect } from "react";
import api from "@/lib/api";

const map = {
  primary: "--dir-gold",
  primaryHover: "--dir-gold-hover",
  secondary: "--dir-elevated",
  accent: "--dir-light",
  background: "--dir-bg",
  surface: "--dir-card",
  surfaceAlternate: "--dir-deep",
  headingText: "--dir-text",
  bodyText: "--dir-body",
  mutedText: "--dir-muted",
  border: "--dir-border",
  success: "--dir-success",
  warning: "--dir-warning",
  error: "--dir-error",
};
const safeColor = (value) => typeof value === "string" && (/^#[0-9a-f]{3,8}$/i.test(value.trim()) || /^(rgb|hsl)a?\([^)]+\)$/i.test(value.trim()));
const finite = (value, min, max) => Number.isFinite(Number(value)) && Number(value) >= min && Number(value) <= max;
export default function BuilderTheme() {
  useEffect(() => {
    api
      .get("/site-builder/config")
      .then(({ data }) => {
        const styles = data?.global_styles || {},
          colors = styles.colors || {},
          type = styles.typography || {},
          root = document.documentElement;
        Object.entries(map).forEach(
          ([k, v]) => safeColor(colors[k]) && root.style.setProperty(v, colors[k]),
        );
        if (type.headingFont)
          root.style.setProperty(
            "--font-heading",
            `'${type.headingFont}', serif`,
          );
        if (type.bodyFont)
          root.style.setProperty(
            "--font-body",
            `'${type.bodyFont}', sans-serif`,
          );
        if (type.navigationFont)
          root.style.setProperty(
            "--font-navigation",
            `'${type.navigationFont}', sans-serif`,
          );
        [
          ["h1", "--type-h1"],
          ["h2", "--type-h2"],
          ["h3", "--type-h3"],
          ["h4", "--type-h4"],
          ["body", "--type-body"],
          ["small", "--type-small"],
          ["button", "--type-button"],
        ].forEach(([k, p]) => {
          const v = type[k];
          if (v && typeof v === "object") {
            if (finite(v.size, 8, 120)) root.style.setProperty(`${p}-size`, `${v.size}px`);
            if (finite(v.weight, 100, 900)) root.style.setProperty(`${p}-weight`, v.weight);
            if (finite(v.lineHeight, 0.8, 3)) root.style.setProperty(`${p}-line`, v.lineHeight);
            root.style.setProperty(
              `${p}-tracking`,
              `${v.letterSpacing || 0}em`,
            );
          }
        });
      })
      .catch(() => {});
  }, []);
  return null;
}
